import { ReactNode } from 'react'
import PublicFooter from '../PublicFooter'
import CryptoRain from './CryptoRain'
import Logo from '../Logo'

// Shared styles for the dark sign-in / register forms.
export const authLabelClass = 'block text-sm font-medium text-gray-300'
export const authInputClass =
  'mt-1 block w-full rounded-lg border border-white/10 bg-black/40 px-3 py-2.5 text-base text-gray-100 placeholder-gray-500 transition-colors focus:border-accent/60 focus:outline-none focus:ring-2 focus:ring-accent/30 sm:text-sm'
export const authLinkClass = 'font-medium text-accent hover:text-accent-hover'
export const authButtonClass =
  'flex w-full items-center justify-center gap-2 rounded-lg bg-accent px-4 py-2.5 text-sm font-semibold text-gray-950 shadow-lg shadow-accent/20 transition-colors hover:bg-accent-hover focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-gray-950 disabled:cursor-not-allowed disabled:opacity-50'
export const authSpinnerClass = 'border-gray-950 border-t-transparent'

interface AuthShellProps {
  heading?: string
  subheading?: string
  children: ReactNode
}

const AuthShell = ({ heading, subheading, children }: AuthShellProps) => (
  <main className="relative min-h-screen overflow-x-clip bg-[#050a08] text-gray-100">
    <CryptoRain />
    <div className="relative flex min-h-screen flex-col items-center justify-center px-4 py-10">
      <div className="relative w-full max-w-md">
        {/*
          Soft green light source behind the card so it floats forward.
          Static and faint; the card itself stays the brightest thing on screen.
        */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -inset-x-24 -inset-y-20 bg-[radial-gradient(closest-side,rgba(34,197,94,0.13),rgba(34,197,94,0.04)_60%,transparent)]"
        />
        {/*
          Mostly-opaque card so text never depends on the blur. The blur is
          smaller on phones, where re-blurring the moving canvas costs the most.
        */}
        <div className="relative w-full rounded-2xl border border-white/10 bg-[#0a110e]/95 p-6 shadow-2xl shadow-black/60 supports-[backdrop-filter]:bg-[#0a110e]/80 supports-[backdrop-filter]:backdrop-blur-sm sm:p-8 sm:supports-[backdrop-filter]:bg-[#0a110e]/70 sm:supports-[backdrop-filter]:backdrop-blur-md">
          <div className="mb-8 text-center">
            <h1 className="text-3xl font-bold tracking-tight text-white">
              <span aria-hidden="true" className="mr-2 align-middle text-xl text-accent">
                ▲
              </span>
              <Logo size="xl" tone="dark" />
            </h1>
            <p className="mt-2 text-sm text-accent/80">honest crypto signals &amp; content</p>
            {heading && <h2 className="mt-6 text-lg font-semibold text-gray-100">{heading}</h2>}
            {subheading && <p className="mt-1 text-sm text-gray-400">{subheading}</p>}
          </div>
          {children}
        </div>
      </div>
      <PublicFooter />
    </div>
  </main>
)

export default AuthShell
